import { render, staticRenderFns } from "./WaitingReservationRegistration.vue?vue&type=template&id=27054f8c&scoped=true&"
import script from "./WaitingReservationRegistration.vue?vue&type=script&lang=js&"
export * from "./WaitingReservationRegistration.vue?vue&type=script&lang=js&"
import style0 from "./WaitingReservationRegistration.vue?vue&type=style&index=0&id=27054f8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27054f8c",
  null
  
)

export default component.exports